export default __webpack_public_path__ + "static/media/svyasa.3aff08f9.png";